export default __webpack_public_path__ + "static/media/NoQuestions.60679c2d.svg";